import _ from 'lodash';
import Collection from './Collection.js';

/**
 * This class wraps a "group data structure" to make it chainable when using the "groupBy"
 * method on the RelatedAggregateCollection, AggregateCollection and Collection classes.
 *
 * Except for the collections classes, no code should create instances of the Grouping class.
 *
 * Usage (from an AggregateCollection instance)
 *   SR.find(criteria)
 *     .groupBy('key')   // <======== this line returns a Grouping instance
 *     .filter(()=>condition)
 *     .take(1);
 */

export default class Grouping {
  constructor(groups) {
    if (!groups) {
      throw new Error('Invalid grouping');
    }

    Object.assign(this, _.mapValues(groups, Collection.fromArray));
  }

  filter(predicate) {
    return Collection.fromArray(_.filter(this, predicate));
  }

  map(fnOrProp) {
    return Collection.fromArray(_.map(this, fnOrProp));
  }

  toArray() {
    return Collection.fromArray(_.values(this));
  }

  [Symbol.iterator]() {
    return this.toArray();
  }
}
